export const env = {
  NODE_ENV: 'production',
  CLIENT_ID: 'map-render',
  URL: {
    HOST: 'https://map-render.neogig.com.br',
    NEOGIG_API: 'https://neogig-api.neogig.com.br',
    NEOGIG_IMAGE: 'https://www.neogig.com.br/static/images',
    IDENTITY_SERVER: 'https://identity-server.neogig.com.br',
  }
};
